(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('combobox', function($document) {
    return {
        restrict: 'E',
        replace: true,
        priority: 1,
        scope: {
            term: '=',
            listData: '=',
            textProperty: '@',
            click: '&',
            placeholder: '@',
            triggerLabel: '@',
            triggerClick: '&',
            inputClass: '@',
            enableAutocomplete: '@',
            rootForm: '=',
            lookupEnabled: '='
        },
        transclude: true,
        controller: _controller,
        templateUrl: (element, attr) => {
            let base = 'partials';
            if (attr.templateVersion) {
                return `${base}/booking/template?name=Combobox&version=${attr.templateVersion}`;
            }
            return `${base}/home/directivetemplate?type=ComboBox`;
        },
        link: _linker
    };

    function _controller($scope, $element) {
        this.element = $element;
    }

    function _linker(scope, e) {
        scope.autocomplete = !TRPCONFIG.Domain.isAgentMode && scope.enableAutocomplete || 'off';

        function toggleMenu(val) {
            scope.$evalAsync(() => {
                scope.menu = val;
            });
        }

        e.on('focusin', function() {
            if (scope.listData && scope.listData.length > 0) {
                toggleMenu(true);
            }
        });

        function mousedown(e) {
            if ($(e.target).closest('.cmb-menu').length === 0) {
                toggleMenu(false);
            }
        }

        // This is needed to hide the menu on a sort of focus-out event
        // (basically if the user does not click on the menu-list this will hide it)
        $document.on('mousedown', mousedown);

        scope.$on('$destroy', function() {
            e.off('focusin');
            $document.off('mousedown', mousedown);
        });

        scope.clickHandler = function(d) {
            scope.click({ item: d });
            scope.loading = true;
        };

        scope.$watch('term', () => {
            scope.listData = [];
        });

        scope.triggerClickHandler = () => {
            scope.submitted = true;
            scope.triggerClick({ term: scope.term });
            e.find('input').focus();
        };

        // If the listData has changed (mainly due to a new filter being
        // applied) this will make it visible
        scope.$watch('listData', function(value) {
            scope.loading = false;
            if (!value || value.length === 0) {
                scope.menu = false;
            } else {
                scope.menu = true;
            }
        });
    }
});
})();
